import GrabbableWindow from "./GrabbableWindow";

export default class DragResizer {
  constructor(elSizeTarget, elPositionTarget, direction, minSize, update = () => {}, onFinish = () => {}) {
    this._elSizeTarget = elSizeTarget;
    this._elPositionTarget = elPositionTarget;
    this._direction = direction;
    this._minSize = minSize;
    this._update = update;
    this._onFinish = onFinish;
  }
  start(x, y) {
    this._startX = x;
    this._startY = y;
    this._startWidth = this._elSizeTarget.width;
    this._startHeight = this._elSizeTarget.height;
    const rect = this._elPositionTarget.getBoundingClientRect();
    this._startLeft = rect.x;
    this._startTop = rect.y;
  }
  drag(x, y) {
    let dx = x - this._startX;
    let dy = y - this._startY;
    switch(this._direction) {
      case 'lt':
        if(this._startWidth - dx < this._minSize) dx = this._startWidth - this._minSize;
        if(this._startHeight - dy < this._minSize) dy = this._startHeight - this._minSize;
        this._elSizeTarget.width = this._startWidth - dx;
        this._elSizeTarget.height = this._startHeight - dy;
        this._elPositionTarget.style.left = GrabbableWindow.pxToPercentX(this._startLeft + dx);
        this._elPositionTarget.style.top = GrabbableWindow.pxToPercentY(this._startTop + dy);
        this.onResizeLeft && this.onResizeLeft(dx);
        this.onResizeTop && this.onResizeTop(dy);
        break;
      case 'rt':
        if(this._startWidth + dx < this._minSize) dx = this._minSize - this._startWidth;
        if(this._startHeight - dy < this._minSize) dy = this._startHeight - this._minSize;
        this._elSizeTarget.width = this._startWidth + dx;
        this._elSizeTarget.height = this._startHeight - dy;
        this._elPositionTarget.style.top = GrabbableWindow.pxToPercentY(this._startTop + dy);
        this.onResizeRight && this.onResizeRight(dx);
        this.onResizeTop && this.onResizeTop(dy);
        break;
      case 'rb':
        if(this._startWidth + dx < this._minSize) dx = this._minSize - this._startWidth;
        if(this._startHeight + dy < this._minSize) dy = this._minSize - this._startHeight;
        this._elSizeTarget.width = this._startWidth + dx;
        this._elSizeTarget.height = this._startHeight + dy;
        this.onResizeRight && this.onResizeRight(dx);
        this.onResizeBottom && this.onResizeBottom(dy);
        break;
      case 'lb':
        if(this._startWidth - dx < this._minSize) dx = this._startWidth - this._minSize;
        if(this._startHeight + dy < this._minSize) dy = this._minSize - this._startHeight;
        this._elSizeTarget.width = this._startWidth - dx;
        this._elSizeTarget.height = this._startHeight + dy;
        this._elPositionTarget.style.left = GrabbableWindow.pxToPercentX(this._startLeft + dx);
        this.onResizeLeft && this.onResizeLeft(dx);
        this.onResizeBottom && this.onResizeBottom(dy);
        break;
    }
    this._update();
  }
  finish() {
    this._onFinish();
  }
  cancel() {
    this.drag(this._startX, this._startY);
    this._update();
  }
}
